import { useEffect } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { SendMessage } from 'react-use-websocket';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetTransactionsDictionariesQuery,
  useLazyGetTransactionsDictionariesWithoutGLQuery,
  useLazyGetTransactionsBaseCurrencyQuery,
  useLazyGetTransactionsCurrenciesQuery,
  useLazyGetTransactionsCountriesQuery,
} from '../../store/dictionaries/services';
import InternalList from './list';

import cn from './styles.module.css';

const Internal = (): React.JSX.Element => {
  const [getDictionaries] = useLazyGetTransactionsDictionariesQuery();
  const [getDictionariesWithoutGL] =
    useLazyGetTransactionsDictionariesWithoutGLQuery();
  const [getTransactionBaseCurrency] =
    useLazyGetTransactionsBaseCurrencyQuery();
  const [getTransactionCurrencies] = useLazyGetTransactionsCurrenciesQuery();
  const [getTransactionCountries] = useLazyGetTransactionsCountriesQuery();

  const {
    activePermissions,
    pspPartnerAccounts,
    countries,
    currencies,
    baseCurrency,
    accounts,
  } = useAppSelector((state) => state.transactionsDictionaries);
  const { values: transactionsTypes } = useAppSelector(
    (state) => state.settings.transactionsTypes,
  );

  const { sendMessage } = useOutletContext<{ sendMessage: SendMessage }>();

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions?.includes(PermissionEnum.TRANSACTIONS_INTERNAL_LIST)
    ) {
      if (!pspPartnerAccounts) {
        getDictionariesWithoutGL();
      }

      if (!accounts) {
        getDictionaries();
      }

      if (!currencies) {
        getTransactionCurrencies();
      }

      if (!countries) {
        getTransactionCountries();
      }

      if (!baseCurrency) {
        getTransactionBaseCurrency();
      }
    }
  }, [
    activePermissions,
    pspPartnerAccounts,
    countries,
    currencies,
    baseCurrency,
    accounts,
  ]);

  useEffect(() => {
    let title = 'Internal transfers';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.internalLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions && transactionsTypes) {
    if (
      activePermissions.includes(PermissionEnum.TRANSACTIONS_INTERNAL_LIST) &&
      transactionsTypes?.find((item) => item.name === 'INTERNAL')?.active
    ) {
      content = (
        <div className={cn.internal}>
          <InternalList />
          <Outlet context={{ sendMessage }} />
        </div>
      );
    } else {
      content = <PermissionDenied />;
    }
  }

  return content;
};

export default Internal;
